/**
 * @description 投稿タイプ:planの各カテゴリー毎表示、今のところ固定プランの「朝食付きプラン」のみで使用.
 */

import axios from 'axios';
import { swiper3Option } from './setSwiper';
import Swiper from 'swiper';
import { setMatchHeight } from '../common/setMatchHeight';
import { cmsSliderHtml } from './loadcms';

export const loadEachPlan = () => {
  const target = $('.js-each-plan');
  if (!target.length) return;

  const catid = target.data('catid');
  const siteId = sessionStorage.getItem('id');
  if (siteId === 'undefined') {
    target.parents('.contents').hide();
    return;
  }

  axios
    .get(`${location.origin}/wp-json/wp/v2/plan?_fields=id,date,title,link,acf,thumbnail,plan_category,facility_name&order=asc&page=1&per_page=10&facility_name=${siteId}&plan_category=${catid}`)
    .then(function (res) {
      const posts = res.data;
      if (posts.length == 0) {
        target.parents('.contents').hide();
        return;
      }
      let postHtml = ``;
      for (let i = 0; i < posts.length; i++) {
        const post = posts[i];
        const [link, img, title, discription] = [post.link, post.acf.thumb, post.title.rendered, post.acf.discription];
        postHtml += cmsSliderHtml(link, img, title, discription);
      }
      target[0].innerHTML = postHtml;
      new Swiper('.js-swiper3', swiper3Option);
    })
    .catch((error) => {
      console.info(error);
    });
  setMatchHeight();
};
